import { cloneSafe } from 'Utils/components.ts';
import { getParams, getImageOrDefault } from './tile.tsx';

import type { FC } from 'react';
import type { TemplateFunction, TemplateFunctionInvoker } from 'Components/types.ts';
import type { FacetRequest, FacetValueFull } from 'Models/index.ts';
import type { SubvalueParams } from './tile.tsx';

type Props = {
  template: TemplateFunction<SubvalueParams>;
  subvalue: FacetValueFull;
  isMultiLevel?: boolean;
  toggleFacet: (term: string) => void;
  useFilterMode?: boolean;
  vehicleFromUriSelection: FacetRequest[];
  vehicleWidget?: TemplateFunctionInvoker<unknown>;
};

const Subtile: FC<Props> = ({
  template,
  subvalue,
  isMultiLevel,
  toggleFacet,
  useFilterMode,
  vehicleFromUriSelection,
  vehicleWidget,
}) => {
  const component = template.call({
    ...getParams(subvalue, vehicleFromUriSelection),
    isMultiLevel,
    getImageOrDefault,
    vehicleWidget,
  });

  const options = useFilterMode
    ? {
        onClick: (e: React.MouseEvent) => {
          e.preventDefault();
          toggleFacet(subvalue.term);
        },
      }
    : {};

  return cloneSafe(component, null, { ...options });
};

export default Subtile;
